import React from 'react';
import PropTypes from 'prop-types';
import RpTable, { NoData } from 'rp-react-table';
import { sharedColumns, firstColumns } from './columns';

const tables = ['course', 'distance', 'going', 'month', 'jockey', 'class'];

const StatsTables = ({ data, raceType }) => (
    data ? (
        <div>
            {tables.map(tableKey => (
                <RpTable
                    data={data[tableKey]}
                    columns={[
                        firstColumns[tableKey],
                        ...sharedColumns,
                    ]}
                    className="hp-stats__table"
                    sortable
                    initialSortIdx={0}
                    key={tableKey}
                />
            ))}
        </div>
    ) : (
        <NoData
            text={`No stats for this horse ${
                raceType === 'flat' ? 'on the Flat' : 'over Jumps'
            }`}
        />
    )
);

const sharedPropTypes = {
    startsNumber: PropTypes.number,
    place1stNumber: PropTypes.number,
    place2ndNumber: PropTypes.number,
    place3rdNumber: PropTypes.number,
    winPrize: PropTypes.number,
    totalPrize: PropTypes.number,
    bestRpTopspeed: PropTypes.number,
    bestRpPostmark: PropTypes.number,
};

StatsTables.propTypes = {
    data: PropTypes.shape({
        statistics: PropTypes.shape({
            course: PropTypes.arrayOf(PropTypes.shape({
                courseUid: PropTypes.number,
                course: PropTypes.string,
                courseTypeCode: PropTypes.string,
                courseStyleName: PropTypes.string,
                courseKey: PropTypes.string,
                courseComment: PropTypes.string,
                ...sharedPropTypes,
            })).isRequired,
            distance: PropTypes.arrayOf(PropTypes.shape({
                distanceYard: PropTypes.number.isRequired,
                ...sharedPropTypes,
            })).isRequired,
            going: PropTypes.arrayOf(PropTypes.shape({
                goingTypeDesc: PropTypes.string,
                ...sharedPropTypes,
            })).isRequired,
            month: PropTypes.arrayOf(PropTypes.shape({
                month: PropTypes.number,
                monthName: PropTypes.string,
                ...sharedPropTypes,
            })).isRequired,
            jockey: PropTypes.arrayOf(PropTypes.shape({
                jockeyUid: PropTypes.number,
                jockeyStyleName: PropTypes.string,
                jockeyShortName: PropTypes.string,
                jockeyPtpTypeCode: PropTypes.string,
                ...sharedPropTypes,
            })).isRequired,
            class: PropTypes.arrayOf(PropTypes.shape({
                class: PropTypes.string.isRequired,
                ...sharedPropTypes,
            })).isRequired,
        }),
    }),
    raceType: PropTypes.string,
};

export default StatsTables;



// WEBPACK FOOTER //
// ./src/js/horse/stats/StatsTables.jsx